import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden bg-cream py-8 md:py-11" aria-hidden data-testid="marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-cream to-transparent md:w-44" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-cream to-transparent md:w-44" />
      <div className="marquee-track gap-10 md:gap-16">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap md:gap-16">
            <span className="text-xs font-semibold uppercase tracking-[0.28em] text-charcoal-700 md:text-sm">
              {item}
            </span>
            <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-clay/70" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
};
